import { useState } from 'react';
import { testimonials } from '../../../mocks/testimonials';

export default function TestimonialSlider() {
  const [current, setCurrent] = useState(0);
  const prev = () => setCurrent((c) => (c === 0 ? testimonials.length - 1 : c - 1));
  const next = () => setCurrent((c) => (c === testimonials.length - 1 ? 0 : c + 1));

  return (
    <section id="yorumlar" className="py-20 md:py-28 bg-warm-dark overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <span className="text-xs font-medium tracking-[0.2em] text-gold uppercase mb-3 block">Danışan Yorumları</span>
          <h2 className="font-serif text-3xl md:text-4xl font-light text-cream-dark">Onlar ne dedi?</h2>
        </div>
        <div className="relative max-w-3xl mx-auto">
          <div className="bg-white/5 border border-white/10 rounded-2xl p-8 md:p-12 text-center">
            <div className="flex justify-center mb-4 gap-1">
              {Array.from({ length: testimonials[current].rating }).map((_, i) => (
                <i key={i} className="ri-star-fill text-gold text-base" />
              ))}
            </div>
            <p className="font-serif text-xl md:text-2xl font-light text-cream-dark italic leading-relaxed mb-8">
              "{testimonials[current].comment}"
            </p>
            <div className="flex flex-col items-center gap-1">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-gold text-white font-serif font-semibold text-sm">
                {testimonials[current].initials}
              </div>
              <p className="text-warm-pale font-medium text-sm mt-2">{testimonials[current].name}</p>
              <p className="text-warm-pale/50 text-xs">{testimonials[current].service}</p>
            </div>
          </div>
          <div className="flex justify-center gap-4 mt-8">
            <button onClick={prev} className="w-10 h-10 flex items-center justify-center rounded-full border border-white/20 text-warm-pale hover:border-gold hover:text-gold transition-colors cursor-pointer">
              <i className="ri-arrow-left-line" />
            </button>
            {testimonials.map((_, i) => (
              <button key={i} onClick={() => setCurrent(i)}
                className={`w-2 h-2 rounded-full transition-all cursor-pointer ${i === current ? 'bg-gold w-6' : 'bg-white/20'}`} />
            ))}
            <button onClick={next} className="w-10 h-10 flex items-center justify-center rounded-full border border-white/20 text-warm-pale hover:border-gold hover:text-gold transition-colors cursor-pointer">
              <i className="ri-arrow-right-line" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}